export enum IdpProvider {
  Azure = 0,
  OktaAuthServer = 1,
  OktaNoAuthServer = 2,
  Google = 3,
  PingOne = 4,
  OneLogin = 5,
}
